module.exports = __webpack_public_path__ + "static/gdpr.ef5f1cba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gdpr.svg
// module id = 405
// module chunks = 35783957827783